import {getCancelReasons} from './get-cancel-reasons'
import {sendAdditionalForm} from './send-additional-form'
import {sendReorderForm} from './send-reorder-form'

export const reorderApi = {
  sendReorderForm,
  sendAdditionalForm,
  getCancelReasons,
}